module.exports = __webpack_public_path__ + "static/img/son3_active.285ba8b4.jpg";